import React from 'react';
import CategoryBase from '../Component/CategoryBase';

const CategoryProductiveManagement = () => {
  return <CategoryBase baseEndpoint="category_productive_management" />;
};

export default CategoryProductiveManagement;
